export const PUBLICATION_LIST = {
  breakingNewsMsg: 'Новость-молния',
  draftMsg: 'Черновики',
  publishedMsg: 'Опубликованные',
  publishMsg: 'Опубликовать',
  reviewMsg: 'На проверку',
  unpublishedMsg: 'Снятые с сайта'
}
